module.exports = __webpack_public_path__ + "static/media/checkmark-green-bg.5dbb4896.svg";